<template>
    <nav role="navigation">
        <div id="menu-toggle" :class="$mq">
            <input id="menu-input" type="checkbox" />

            <span />
            <span />

            <ul id="menu">
                <div>
                    <router-link
                        v-for="(menuItem, index) in menu"
                        :key="index"
                        :to="menuItem.route"
                    >
                        <li class="menu-item" @click="closeMenu">
                            {{ menuItem.label }}
                        </li>
                    </router-link>
                </div>

                <li @click="closeMenu">
                    <base-button
                        type="router-link"
                        to="/contact"
                        design="secondary"
                        width="100%"
                        class="contact-btn"
                    >
                        Contact Us
                    </base-button>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
    export default {
        name: 'hamburger-menu',

        data() {
            return {
                menu: [
                    { route: '/', label: 'Home' },
                    { route: '/covid-19', label: 'Covid-19' },
                    { route: '/portfolio', label: 'Portfolio' },
                    { route: '/team', label: 'Team' },
                    { route: '/awards', label: 'Awards' },
                    {
                        route: '/shortlisting-panel',
                        label: 'Shortlisting Panel',
                    },
                    { route: '/judges', label: 'Judges' },
                    { route: '/sponsors', label: 'Sponsors' },
                    { route: '/past-projects', label: 'Past Projects' },
                    { route: '/submission', label: 'Submission' },
                ],
            };
        },

        mounted() {
            document
                .querySelector('#page')
                .addEventListener('click', this.closeMenu);
        },

        destroyed() {
            document
                .querySelector('#page')
                .destroyEventListener('click', this.closeMenu);
        },

        methods: {
            closeMenu() {
                document.getElementById('menu-input').checked = false;
            },
        },
    };
</script>

<style lang="scss" scoped>
    $menu-width: 250px;

    #menu-toggle {
        display: block;
        position: fixed;
        top: $standard-space;
        right: $standard-space;
        z-index: 10;
        -webkit-user-select: none;
        user-select: none;

        &.mobile {
            top: $standard-space-mobile;
            right: $standard-space-mobile;
        }
    }

    #menu-toggle input {
        display: block;
        width: 40px;
        height: 32px;
        position: absolute;
        top: -7px;
        left: -5px;
        cursor: pointer;
        opacity: 0; /* hide this */
        z-index: 2; /* and place it over the hamburger */
        -webkit-touch-callout: none;
    }

    /*
    * Just a quick hamburger
    */
    #menu-toggle span {
        display: block;
        width: 33px;
        height: 4px;
        margin-bottom: 5px;
        position: relative;
        background: #fff;
        z-index: 1;
        transform-origin: 4px 0px;
        transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
            background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease;
    }

    #menu-toggle span:first-child {
        transform-origin: 0% 0%;
    }

    #menu-toggle span:nth-last-child(2) {
        transform-origin: 0% 100%;
    }

    /*
    * Transform all the slices of hamburger
    * into a crossmark.
    */
    #menu-toggle input:checked ~ span {
        opacity: 1;
        transform: rotate(-45deg) translate(-4px, 4px);
    }

    /*
    * The last one should go the other direction
    */
    #menu-toggle input:checked ~ span:nth-last-child(3) {
        transform: rotate(45deg) translate(-4px, -2px);
    }

    /*
    * Make this absolute positioned
    * at the top left of the screen
    */
    #menu {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: absolute;
        width: $menu-width;
        height: calc(100vh - 140px);
        margin: -100px 0 0 0 -$menu-width;
        padding: 125px 50px 75px;
        background: $blue;
        list-style-type: none;
        -webkit-font-smoothing: antialiased;
        /* to stop flickering of text in safari */
        transform-origin: 0% 0%;
        transform: translate(100%, 0);
        transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);
        box-shadow: -10px 0px 20px 0px rgba(0, 0, 0, 0.1);
    }

    #menu .menu-item {
        padding: 20px 0;
        font-size: 22px;
        text-transform: uppercase;
    }

    #menu a {
        color: #fff;
        text-decoration: none;
        &:hover {
            color: darken(#fff, 5%);
            text-decoration: none;
            font-weight: bold;
        }
    }

    /*
    * And let's slide it in from the left
    */
    #menu-toggle input:checked ~ ul {
        transform: none;
    }
</style>
